const selectors = {
    isActive: 'is-active'
}

const toggleTab = ([tabFamily, tabID]) => {
    const
        activeTab = document.querySelector(`div.${selectors.isActive}[data-tab^="${tabFamily}"]`),
        event = new CustomEvent('tab:close', {
            cancelable: true,
            bubbles: true,
        })

    if (activeTab.dispatchEvent(event)) {
        const
            targetTab = document.querySelector(`div[data-tab="${tabFamily}|${tabID}"]`),
            event = new CustomEvent('tab:open', {
                cancelable: true,
                bubbles: true,
            })

        if (targetTab.dispatchEvent(event)) {
            document.querySelectorAll(`[data-tab^="${tabFamily}"]`).forEach(el => el.classList.toggle(selectors.isActive, el.matches(`[data-tab="${tabFamily}|${tabID}"]`)))
        }
    }
}

const initTabs = () => {
    document.addEventListener('click', e => {
        if (e.target.matches('[data-tab]') && !e.target.matches('div')) {
            e.preventDefault()
            toggleTab(e.target.dataset.tab.split('|'))
        }
    })

    return false;
}

export default initTabs()
export {toggleTab}
